// ハッシュ付き URL で開いたときの着地位置: <section id="program-details" data-mp-hash-align>
// 画像の読み込みで高さが変わっても、対象の scroll-margin-top を守った位置に揃え直す
// （読み込み直後・0.5 秒後・1.2 秒後）。利用者が自分でスクロールしたら以後は触らない。

export function setupHashAlign() {
  const targets = [...document.querySelectorAll('[data-mp-hash-align]')];
  if (targets.length === 0) return;

  let userMoved = false;
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => {
    window.addEventListener(type, () => { userMoved = true; }, { passive: true });
  });

  const align = () => {
    if (userMoved || !location.hash) return;
    const target = targets.find((el) => '#' + el.id === location.hash);
    if (!target) return;
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, window.scrollY + target.getBoundingClientRect().top - offset);
    requestAnimationFrame(() => { root.style.scrollBehavior = previous; });
  };
  const synchronize = () => {
    align();
    setTimeout(align, 500);
    setTimeout(align, 1200);
  };

  if (location.hash) synchronize();
  if (document.readyState === 'complete') synchronize();
  else window.addEventListener('load', synchronize, { once: true });
  window.addEventListener('pageshow', synchronize);
  window.addEventListener('hashchange', () => {
    userMoved = false;
    synchronize();
  });
}
